import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { poPdfLabelEditorQueryConfig } from '@webapp/modules/purchasing/query-configs/poPdfLabelEditor'
import {
  PDFLabelSet,
  type PDFLabelSetConstructor,
} from '@webapp/modules/vendor/entities/PDFLabelSet' // eslint-disable-line import/no-internal-modules

type UseQueryInitialPOPDFLabelSetReturn = {
  initialSet: PDFLabelSet | null
  isLoading: boolean
  error: RepoError | null
}

export const useQueryInitialPOPDFLabelSet =
  (): UseQueryInitialPOPDFLabelSetReturn => {
    const { data, isLoading, error } = useQuery<
      PDFLabelSetConstructor | null,
      RepoError
    >(poPdfLabelEditorQueryConfig.initialSet())

    const initialSet = useMemo(
      () => (data ? new PDFLabelSet(data) : null),
      [data]
    )

    return {
      initialSet,
      isLoading,
      error: error ?? null,
    }
  }
